import { ReactNode } from 'react';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import {
  AmexIcon,
  DinersClubIcon,
  DiscoverIcon,
  EditIcon,
  GeneralIcon,
  MasterCardIcon,
  PaymentSize,
  VisaIcon,
} from 'src/svgs/Viagogo';
import { BuyerWithSalesDto } from 'src/WebApiController';

import * as styles from './BuyerCard.css';

export function getCardBrandIcon(brand: string | null | undefined): ReactNode {
  const normalized = brand?.toLowerCase();
  if (normalized === 'visa') return <VisaIcon size={PaymentSize.s} />;
  if (normalized === 'mc' || normalized === 'mastercard')
    return <MasterCardIcon size={PaymentSize.s} />;
  if (normalized === 'amex' || normalized === 'american express')
    return <AmexIcon size={PaymentSize.s} />;
  if (normalized === 'discover') return <DiscoverIcon size={PaymentSize.s} />;
  if (normalized === 'diners') return <DinersClubIcon size={PaymentSize.s} />;
  return <GeneralIcon size={PaymentSize.s} />;
}

type BuyerCardProps = {
  buyer: BuyerWithSalesDto;
  onEdit?: (buyer: BuyerWithSalesDto) => void;
};

export const BuyerCard = ({ buyer, onEdit }: BuyerCardProps) => {
  const {
    buyerName,
    buyerEmail,
    billingCity,
    billingState,
    cardBrand,
    cardSummary,
  } = buyer;

  const addressParts = [billingCity, billingState].filter(Boolean);

  const addressText = addressParts.join(' · ');

  return (
    <Stack
      alignItems="center"
      justifyContent="spaceBetween"
      gap="m"
      width="full"
      className={styles.card}
    >
      <Stack direction="column" flexWrap="grow" style={{ minWidth: 0 }}>
        {buyerName && <span className={styles.name}>{buyerName}</span>}
        <Stack alignItems="center" className={styles.metaRow}>
          <span className={styles.email}>{buyerEmail}</span>
          <span className={styles.separator}>|</span>
          {addressText ? (
            <span>{addressText}</span>
          ) : (
            <div className={styles.emptyDash} style={{ width: '60px' }} />
          )}
          <span className={styles.separator}>|</span>
          {cardSummary ? (
            <Stack alignItems="center" gap="s" flexShrink={false}>
              {getCardBrandIcon(cardBrand)}
              <span>••••{cardSummary}</span>
            </Stack>
          ) : (
            <div className={styles.emptyDash} style={{ width: '40px' }} />
          )}
        </Stack>
      </Stack>
      {onEdit && (
        <button
          type="button"
          className={styles.editButton}
          onClick={(e) => {
            e.stopPropagation();
            onEdit(buyer);
          }}
        >
          <EditIcon size={vars.iconSize.m} />
        </button>
      )}
    </Stack>
  );
};
